import { Target } from "./target"

export class GeoItem {
    id: string
    target: Target
    display: string
    location: Location
  }